import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default async ({ entityId, input }) => {
	const query = gql`
		mutation updateIndividual($id: String!, $input: updateIndividualInput!) {
			updateIndividual(id: $id, updateIndividualInput: $input) {
				status
				errors
			}
		}
	`
	const variables = {
		id: entityId,
		input
	}

	const res = await api({ query, variables })

	return Promise.resolve(res)
}
